module.exports = __webpack_public_path__ + "img/8.a39bbf56.jpg";